import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, fetchShareMeterList, selectPmsTreeWithArea } from '@/api/PMS/baseInformation/meterManager';
import { fetchList as getMeterTypeList } from '@/api/PMS/baseInformation/meterType';
import { getGroupList, getBuildingList, getHouseList } from '@/api/PMS/chargeManagement/frountDeskCharge/prepay';
import waves from '@/directive/waves'; // 水波纹指令

import instrumentAdd from './add';
import changeMeter from './changeMeter';
import addList from './addList';
export default {
  components: {
    instrumentAdd: instrumentAdd,
    changeMeter: changeMeter,
    addList: addList
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      searchId: [],
      options: [],
      cascaderItem: [],
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        meterName: ''
      },
      title: '',
      meterId: '',
      multipleSelection: [],
      meterTypeList: [],
      shareMeterList: [],
      groupList: [],
      buildingList: [],
      houseList: [],
      dialogChangeVIsible: false,
      dialogFormVisible: false,
      dialogListVIsible: false
    };
  },
  watch: {
    searchId: function searchId(val) {
      this.listQuery.id = val[val.length - 1];
    },
    deep: true
  },
  created: function created() {
    // this.loadGroupList()
    this.getList();
    this.loadMenuTree();
    this.loadMeterTypeList();
    this.loadShareMeterList();
  },
  methods: {
    loadMeterTypeList: function loadMeterTypeList() {
      var _this = this;

      getMeterTypeList({}).then(function (r) {
        _this.meterTypeList = r.data.data;
      });
    },
    loadGroupList: function loadGroupList() {
      var _this2 = this;

      getGroupList({}).then(function (r) {
        _this2.groupList = r.data.data;
      });
    },
    groupChange: function groupChange() {
      // 清理房间id,楼栋id
      if (this.listQuery.buildingId) {
        delete this.listQuery.buildingId;
      }

      if (this.listQuery.houseId) {
        delete this.listQuery.houseId;
      }

      if (this.listQuery.shareMeterId) {
        delete this.listQuery.shareMeterId;
      }

      this.buildingList = [];
      this.houseList = [];
      this.shareMeterList = [];

      if (this.listQuery.areaId) {
        this.loadBuildingList();
        this.loadShareMeterList();
      }
    },
    // 获取总表列表
    loadShareMeterList: function loadShareMeterList() {
      var _this3 = this;

      fetchShareMeterList({
        shareType: 1,
        areaId: this.listQuery.id
      }).then(function (r) {
        console.log(r.data.data);
        _this3.shareMeterList = r.data.data;
      });
    },
    loadBuildingList: function loadBuildingList() {
      var _this4 = this;

      getBuildingList({
        areaGroupId: this.listQuery.areaId
      }).then(function (r) {
        _this4.buildingList = r.data.data;
      });
    },
    buildingChange: function buildingChange() {
      // 清理房间id
      if (this.listQuery.houseId) {
        delete this.listQuery.houseId;
      }

      if (this.listQuery.buildingId) {
        this.loadHouseList();
      }
    },
    loadHouseList: function loadHouseList() {
      var _this5 = this;

      getHouseList({
        buildingId: this.listQuery.buildingId
      }).then(function (r) {
        _this5.houseList = r.data.data;
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    handCancleChange: function handCancleChange(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogChangeVIsible = false;
    },
    handCancleList: function handCancleList(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogListVIsible = false;
    },
    getList: function getList() {
      var _this6 = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this6.list = response.data.data;
        _this6.total = response.data.total;
        _this6.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.meterId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(meterId) {
      this.meterId = meterId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    handleChangeMeter: function handleChangeMeter(meterId) {
      this.meterId = meterId;
      this.title = '换表';
      this.dialogChangeVIsible = true;
    },
    // 批量添加
    handleAddList: function handleAddList() {
      this.title = '批量添加';
      this.dialogListVIsible = true;
    },
    delete: function _delete(meterIds) {
      var _this7 = this;

      if (meterIds.length > 0) {
        this.$confirm('你确定是要删除这些仪表, 是否继续?', '提示').then(function () {
          fetchDelete({
            ids: meterIds
          }).then(function (response) {
            if (response.data.code === 200) {
              _this7.getList();

              _this7.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(meterId) {
      var meterIds = [];
      meterIds.push(meterId);
      this.delete(meterIds);
    },
    handleDeletes: function handleDeletes() {
      var meterIds = [];
      this.multipleSelection.forEach(function (row) {
        meterIds.push(row.houseMeterId);
      });
      this.delete(meterIds);
    },
    // 获取具体的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this8 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this8.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    handTreeSelect: function handTreeSelect(val) {
      this.cascaderItem = [];
      this.getCascaderItem(this.searchId, this.options); // 如果当前没有数据了，就删除掉dataType

      if (this.cascaderItem.length <= 0) {
        delete this.listQuery.dataType;
      } else {
        this.listQuery.dataType = this.cascaderItem[this.cascaderItem.length - 1].flag;
        console.log(this.listQuery.dataType);
      }

      if (this.listQuery.dataType === 0) {
        // 根据小区名称查总表
        this.loadShareMeterList();
      }
    },
    loadMenuTree: function loadMenuTree() {
      var _this9 = this;

      var treeQuery = {
        flag: 0
      };
      selectPmsTreeWithArea(treeQuery).then(function (response) {
        _this9.options = response.data.data;
      });
    }
  }
};